var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9163 19.0416C35.1334 19.3813 34.3053 19.6059 33.458 19.7083C34.3519 19.1743 35.0218 18.3341 35.3434 17.3437C34.5034 17.8438 33.5838 18.1961 32.6247 18.3854C31.9836 17.6902 31.1298 17.2274 30.1974 17.0696C29.2649 16.9119 28.3065 17.0681 27.4724 17.5137C26.6383 17.9594 25.9756 18.6693 25.5885 19.5321C25.2013 20.3949 25.1114 21.3618 25.333 22.2812C23.6345 22.1953 21.9731 21.7531 20.4566 20.9832C18.9402 20.2133 17.6026 19.133 16.5309 17.8125C16.155 18.4689 15.9575 19.2123 15.958 19.9687C15.9567 20.6712 16.1291 21.3631 16.4598 21.9829C16.7906 22.6026 17.2695 23.1309 17.8538 23.5208C17.1747 23.5023 16.51 23.3201 15.9163 22.9896V23.0416C15.9214 24.0259 16.2663 24.9782 16.8927 25.7374C17.5191 26.4967 18.3885 27.0163 19.3538 27.2083C18.9822 27.3214 18.5964 27.381 18.208 27.3854C17.9391 27.3822 17.6709 27.3579 17.4059 27.3125C17.6808 28.1592 18.2128 28.8991 18.9279 29.4293C19.6429 29.9595 20.5055 30.2537 21.3955 30.2708C19.8926 31.4534 18.0371 32.0988 16.1247 32.1041C15.7765 32.1053 15.4286 32.0844 15.083 32.0416C17.0355 33.3023 19.3109 33.9716 21.6351 33.9687C23.2389 33.9854 24.83 33.6823 26.3154 33.0771C27.8008 32.472 29.1507 31.5769 30.2863 30.4442C31.4219 29.3115 32.3205 27.9639 32.9294 26.4801C33.5384 24.9962 33.8455 23.4059 33.833 21.8021C33.833 21.625 33.833 21.4375 33.833 21.25C34.6504 20.6404 35.3554 19.8931 35.9163 19.0416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.96dcc24c818293e144eb5f275ab8984f.svg";
export { ForwardRef as ReactComponent };